export default __webpack_public_path__ + "img/3d5686f7b7fcfbc8407821a1d123c88b-UCSB-Registrar.svg";